import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["video", "image"]

  play() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return

    if (this.hasVideoTarget) {
      this.videoTarget.classList.remove('hidden')
      if (this.hasImageTarget) this.imageTarget.classList.add('opacity-0')
      this.videoTarget.play().catch(error => {
        console.log("Video play failed:", error)
      })
    }
  }

  pause() {
    if (this.hasVideoTarget) {
      this.videoTarget.pause()
      this.videoTarget.currentTime = 0
      this.videoTarget.classList.add('hidden')
      if (this.hasImageTarget) this.imageTarget.classList.remove('opacity-0')
    }
  }
}
